import { render } from "./icon-invite.vue?vue&type=template&id=5cbd6274"
import script from "./icon-invite.vue?vue&type=script&lang=js"
export * from "./icon-invite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__